import { useCallback } from 'react';

import { log } from 'utils/log';

import { useRouter } from './useRouter';

/** Update the current URL without navigating. */
export function useUrlUpdate() {
	const router = useRouter();

	const updateUrl = useCallback(
		(newUrl: string) => {
			router
				?.replace(newUrl, undefined, { scroll: false, shallow: true })
				.catch((error) => {
					log.error(`useUrlUpdate error: ${error}`);
				});
		},
		[router],
	);

	return { updateUrl };
}
